import { render } from "./ActiveAccount.vue?vue&type=template&id=488becd0&ts=true"
import script from "./ActiveAccount.vue?vue&type=script&lang=ts"
export * from "./ActiveAccount.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__